import type { ReactNode } from 'react';

/**
 * **Une surface posée sur le fond de travail.**
 *
 * Le modèle de la charte vient du tableau : « **un fond de travail, des surfaces blanches
 * posées dessus** ». C'est ce composant qui rend ce modèle, et rien d'autre ne pose de
 * fond blanc.
 *
 * **Aucune marge externe** — anti-pattern 6 : la page espace ses blocs.
 */
type Props = {
  readonly children: ReactNode;
  /** Une carte cliquable est un bouton, jamais un `div` avec un gestionnaire. */
  readonly onClick?: () => void;
  readonly titreAccessible?: string;
};

export function Carte({ children, onClick, titreAccessible }: Props) {
  const habillage =
    'w-full rounded-4 bg-fond-surface p-4 shadow-1 text-left';

  if (onClick === undefined) {
    return <section className={habillage}>{children}</section>;
  }
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={titreAccessible}
      className={`${habillage} min-h-cible transition-colors duration-1 hover:bg-fond-attenue`}
    >
      {children}
    </button>
  );
}
